module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("\n\t\t\t我的\n\t\t\t"), _c('router-link', {
    attrs: {
      "slot": "right",
      "to": "/user/message"
    },
    slot: "right"
  }, [_c('img', {
    staticStyle: {
      "width": "0.39rem",
      "height": "15px"
    },
    attrs: {
      "src": require("../assets/img/email.png")
    }
  }), _c('badge', {
    staticClass: "msg-count",
    attrs: {
      "text": _vm.msg_count
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "user-info-block"
  }, [_c('router-link', {
    attrs: {
      "to": "/safety"
    }
  }, [_c('span', [_vm._v("欢迎！")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), (_vm.CertState != '审核成功') ? _c('span', {
    staticClass: "no_user"
  }) : _vm._e(), _vm._v(" "), (_vm.CertState === '审核成功') ? _c('span', {
    staticClass: "identity-span identity-yes"
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "money-box"
  }, [_c('router-link', {
    staticClass: "money-item",
    attrs: {
      "to": "/user/finance"
    }
  }, [_c('span', {
    staticClass: "moneySpan"
  }, [_vm._v(_vm._s(_vm.money))]), _vm._v(" "), _c('span', {
    staticClass: "moneyTxt"
  }, [_vm._v("账户余额（元）")])]), _vm._v(" "), _c('router-link', {
    staticClass: "money-item",
    attrs: {
      "to": "/user/cashcoupon"
    }
  }, [_c('span', {
    staticClass: "moneySpan"
  }, [_vm._v(_vm._s(_vm.yhq_count))]), _vm._v(" "), _c('span', {
    staticClass: "moneyTxt"
  }, [_vm._v("可用优惠券")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "proTab"
  }, [_c('p', {
    staticClass: "p-title"
  }, [_vm._v("已开通产品")]), _vm._v(" "), _c('flexbox', {
    attrs: {
      "orient": "vertical"
    }
  }, [_c('flexbox-item', {
    staticStyle: {
      "margin-top": ".17rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/user/freevhost"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple ub-box"
  }, [_c('div', {
    staticClass: "product-left ub-box ub-ver ub-ver-v"
  }, [_c('div', {
    staticClass: "product-num",
    class: {
      'notzero': _vm.product.freehost_count != 0
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.product.freehost_count) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "product-right"
  }, [_c('h4', {
    staticClass: "z-font-size-15 z-lineHeight-30"
  }, [_vm._v("免费虚拟主机")]), _vm._v(" "), _c('p', [_vm._v("开通即用、永久免费、送免备案服务")])])])])], 1), _vm._v(" "), _c('flexbox-item', {
    staticStyle: {
      "margin-top": ".17rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/user/freeserver"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple ub-box"
  }, [_c('div', {
    staticClass: "product-left ub-box ub-ver ub-ver-v"
  }, [_c('div', {
    staticClass: "product-num",
    class: {
      'notzero': _vm.product.freevps_count != 0
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.product.freevps_count) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "product-right"
  }, [_c('h4', {
    staticClass: "z-font-size-15 z-lineHeight-30"
  }, [_vm._v("免费云服务器")]), _vm._v(" "), _c('p', [_vm._v("永久免费、功能强大、送免备案服务")])])])])], 1), _vm._v(" "), _c('flexbox-item', {
    staticStyle: {
      "margin-top": ".17rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/user/freebeian"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple ub-box"
  }, [_c('div', {
    staticClass: "product-left ub-box ub-ver ub-ver-v"
  }, [_c('div', {
    staticClass: "product-num",
    class: {
      'notzero': _vm.product.mba_domain != 0
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.product.mba_domain) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "product-right"
  }, [_c('h4', {
    staticClass: "z-font-size-15 z-lineHeight-30"
  }, [_vm._v("免备案服务")]), _vm._v(" "), _c('p', [_vm._v("提交域名无需备案即可访问")])])])])], 1), _vm._v(" "), _c('flexbox-item', {
    staticStyle: {
      "margin-top": ".17rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/user/host"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple ub-box"
  }, [_c('div', {
    staticClass: "product-left ub-box ub-ver ub-ver-v"
  }, [_c('div', {
    staticClass: "product-num",
    class: {
      'notzero': _vm.product.vhost_count != 0
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.product.vhost_count) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "product-right"
  }, [_c('h4', {
    staticClass: "z-font-size-15 z-lineHeight-30"
  }, [_vm._v("虚拟主机")]), _vm._v(" "), _c('p', [_vm._v("共享和独享IP虚拟主机随意选")])])])])], 1), _vm._v(" "), _c('flexbox-item', {
    staticStyle: {
      "margin-top": ".17rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/user/serverManage"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple ub-box"
  }, [_c('div', {
    staticClass: "product-left ub-box ub-ver ub-ver-v"
  }, [_c('div', {
    staticClass: "product-num",
    class: {
      'notzero': _vm.product.vps_count != 0
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.product.vps_count) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "product-right"
  }, [_c('h4', {
    staticClass: "z-font-size-15 z-lineHeight-30"
  }, [_vm._v("云服务器")]), _vm._v(" "), _c('p', [_vm._v("不同配置满足您不同的应用")])])])])], 1), _vm._v(" "), _c('flexbox-item', {
    staticStyle: {
      "margin-top": ".17rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/user/domain"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple ub-box"
  }, [_c('div', {
    staticClass: "product-left ub-box ub-ver ub-ver-v"
  }, [_c('div', {
    staticClass: "product-num",
    class: {
      'notzero': _vm.product.domain_count != 0
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.product.domain_count) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "product-right"
  }, [_c('h4', {
    staticClass: "z-font-size-15 z-lineHeight-30"
  }, [_vm._v("域名")]), _vm._v(" "), _c('p', [_vm._v("各种后缀域名，开启网络第一步")])])])])], 1)], 1)], 1)]), _vm._v(" "), _c('c-footer', {
    attrs: {
      "status": "main"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e99e6d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = OF7n
// module chunks = 1